import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema } from "schema"
import { z } from "zod"

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: async (resetPasswordData: object) => {
      const { data } = await axios.post("/auth/resetPassword", resetPasswordData)
      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
